// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";

// 如果你真要用 Analytics 再引入 getAnalytics
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  databaseURL: "https://koalaquestcanada-9991b-default-rtdb.firebaseio.com",
};

// ② 初始化
const app = initializeApp(firebaseConfig);

// ③ 取出你要用的服務並匯出
export const auth = getAuth(app);
export const db   = getFirestore(app);
export const rtdb = getDatabase(app); 
export const storage = getStorage(app);
// export const analytics = getAnalytics(app); // 真需要再打開
export const functions = getFunctions(app, "us-central1");

// ④ 加入 Google 與 Facebook provider
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();

// ⑤ 可選：提供登入函數封裝（方便元件直接呼叫）
export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);
export const signInWithFacebook = () => signInWithPopup(auth, facebookProvider);
